import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const gears_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M19.5,12.5002 C19.5,16.3862 16.387,19.5002 12.5,19.5002 C8.613,
        19.5002 5.5,16.3862 5.5,12.5002 C5.5,8.6132 8.613,5.5002 12.5,
        5.5002 C16.387,5.5002 19.5,8.6132 19.5,12.5002 Z M15.5,12.5002
        C15.5,14.1832 14.183,15.5002 12.5,15.5002 C10.817,15.5002 9.5,14.1832
        9.5,12.5002 C9.5,10.8172 10.817,9.5002 12.5,9.5002 C14.183,9.5002
        15.5,10.8172 15.5,12.5002 Z M15.5,12.5002 L22,12.5002 M5.5,12.5002
        L3,12.5002 M12.5,5.5002 L12.5,3.0002 M12.5,19.4997 L12.5,21.9997
        M15.8926,18.6335 L16.9996,20.6995 M7.7549,4.3684 L10.9109,9.9434
        M18.6631,15.8396 L20.6561,17.1116 M18.2197,8.446 L20.3257,7.253
        M4.0298,16.7263 L6.1728,15.5133 M7.8276,20.7487 L11.0186,15.1147
        M15.9863,6.4187 L17.2913,4.2147 M4.166,7.799 L6.37,9.104"
      />
    </svg>
  );
};
